import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import { menuItem } from "examples/Items/NotificationItem/styles";

const NotificationItem = forwardRef(({ image, title, date = "", ...rest }, ref) => (
  <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
    <SoftBox mt={0.25} mr={2} ml={-2} mb={0.25}>
      {image}
    </SoftBox>
    <SoftBox>
      <SoftTypography variant="button" textTransform="capitalize" fontWeight="regular">
        {Array.isArray(title) ? (
          <>
            <strong>{title[0]}</strong> {title.slice(1).join(" ")}
          </>
        ) : (
          <strong>{title}</strong>
        )}
      </SoftTypography>
      <SoftTypography
        variant="caption"
        color="secondary"
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 0.5,
        }}
      >
        {date}
      </SoftTypography>
    </SoftBox>
  </MenuItem>
));

// Setting display name for better debugging
NotificationItem.displayName = "NotificationItem";

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  image: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired, // Support both string and array
  date: PropTypes.string,
};

export default NotificationItem;
